import React from 'react';
import PropTypes from 'prop-types';
import lowerCase from 'lodash/lowerCase';

import { Title } from 'components/typography';
import WeeklyReportImage from 'assets/images/analytical-reports/weekly.jpg';
import MonthlyReportImage from 'assets/images/analytical-reports/monthly.jpg';
import QuarterlyReportImage from 'assets/images/analytical-reports/quarterly.jpg';
import OthersReportImage from 'assets/images/analytical-reports/others.jpg';

import {
  reportContainer,
  downloadLink,
} from './scss/AnalyticalReportCard.module.scss';

const AnalyticalReportCard = ({ report, frequency }) => {
  const f = lowerCase(frequency);
  const reportImage =
    {
      weekly: WeeklyReportImage,
      monthly: MonthlyReportImage,
      quarterly: QuarterlyReportImage,
    }[f] || OthersReportImage;

  return (
    <div className={reportContainer}>
      <img src={reportImage} alt={`${f}`} />
      <div>
        <div>
          {report.hasValidDate ? (
            <>
              <Title value={report.day} fontStyle="regular" size="lg" />
              <small>{report.monthAndYear}</small>
            </>
          ) : (
            <>
              <Title value={report.label} fontStyle="regular" size="md" />
            </>
          )}
        </div>
        <a href={report.downloadLink} className={downloadLink} target="__blank">
          Download
        </a>
      </div>
    </div>
  );
};

AnalyticalReportCard.propTypes = {
  frequency: PropTypes.string.isRequired,
  report: PropTypes.shape({}).isRequired,
};

export default AnalyticalReportCard;
